<template>
    <v-carousel 
    hide-delimiters    
    height="350px">      
        <v-carousel-item            
            v-for="(item,i) in medias"
            :key="i"            
            align-center>
            <v-img class="zoom" :src="item.src" contain max-height="300" @click="showMedia(item)">
            <v-container
                v-if="(item.translations.length>0)"
                fill-height>
                <v-layout align-end>          
                    <v-card color="rgb(0, 0, 0, 0.5)">                              
                        <v-card-title class="white--text text-sm-subtitle-2">
                            {{item.translations[0].text}}
                        </v-card-title> 
                    </v-card>
                </v-layout>
            </v-container>
            </v-img>
        </v-carousel-item>
        <v-dialog
            v-model="dialog">
            <v-card>
                <v-card-title class="text-sm-subtitle-1">
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-img :src="currentMedia.src" contain max-height="90%" max-width="90%"></v-img>
                </v-card-text>
            </v-card>
        </v-dialog>   
    </v-carousel>        
</template>

<script>
  export default {
    props: {
        medias: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            dialog: false,
            currentMedia: {src:'', text:''},
        }
    },
    methods:{
        showMedia(item){
            this.currentMedia.src = item.src;
            this.currentMedia.text = item.translations[0].text;
            this.dialog = true;
        }
    }
  }
</script>

<style scoped>
.zoom {
    cursor: zoom-in;
}
</style>